import { useEffect, useState } from "react";
import { Star, X } from "lucide-react";
import { getReviews, fileUrl } from "@/lib/api";

export const Reviews = ({ propertySlug, heading = "What guests say" }) => {
  const [reviews, setReviews] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    getReviews(propertySlug)
      .then((r) => setReviews(r.data))
      .catch(() => setReviews([]));
  }, [propertySlug]);

  if (!reviews.length) return null;

  return (
    <div data-testid="reviews-section">
      <h2 className="font-display text-4xl text-[#0F2A52] mt-16">{heading}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {reviews.map((r) => (
          <figure key={r.id} className="border border-[#0F2A52]/15 p-6" data-testid={`review-${r.id}`}>
            <div className="flex gap-1" aria-label={`${r.rating} out of 5`}>
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={`${r.id}-star-${i}`}
                  size={14}
                  className={i < r.rating ? "fill-[#B08A3E] text-[#B08A3E]" : "text-[#0F2A52]/20"}
                />
              ))}
            </div>
            <blockquote className="text-sm text-[#4A4A4A] leading-relaxed mt-4">“{r.comment}”</blockquote>
            {(r.photos || []).length > 0 && (
              <div className="mt-4" data-testid={`review-photos-${r.id}`}>
                <div className="flex flex-wrap gap-2">
                {r.photos.map((p, i) => (
                  <button
                    key={p}
                    type="button"
                    onClick={() => setLightbox(fileUrl(p))}
                    className="w-20 h-20 overflow-hidden"
                    data-testid={`review-photo-${r.id}-${i}`}
                  >
                    <img
                      src={fileUrl(p)}
                      alt={`Guest photo ${i + 1} from ${r.guest_name}`}
                      loading="lazy"
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                  </button>
                ))}
                </div>
                <p className="text-xs text-[#4A4A4A] mt-2" data-testid={`review-photo-credit-${r.id}`}>
                  Photo{r.photos.length > 1 ? "s" : ""} by {r.guest_name}
                </p>
              </div>
            )}
            <figcaption className="text-xs text-[#0F2A52] mt-4">
              {r.guest_name}
              {r.guest_suburb ? `, ${r.guest_suburb}` : ""}
            </figcaption>
          </figure>
        ))}
      </div>
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-6"
          onClick={() => setLightbox(null)}
          data-testid="review-lightbox"
        >
          <button
            className="absolute top-6 right-6 text-white"
            aria-label="Close photo"
            data-testid="review-lightbox-close"
          >
            <X size={26} />
          </button>
          <img src={lightbox} alt="Guest photo" className="max-h-full max-w-full object-contain" />
        </div>
      )}
    </div>
  );
};

export default Reviews;
